"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectTasks.name': 'Rilevamento Attività',
    'tools.detectTasks.description': 'Rileva ed estrae automaticamente informazioni sulle attività dai messaggi degli utenti',
};
